import type { Template } from "@/types";

export const LA_05_H1_V4: Template[] = [
    {
        id: "la-05-h1v4-01",
        name: "LA 01 - H1V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-05-h1_v4_01.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 43, y: 54, width: 589, height: 375, rotation: 0, imageRotation: 0 },
            { id: "2", x: 855, y: 33, width: 156, height: 205, rotation: 0, imageRotation: 0 },
            { id: "3", x: 855, y: 245, width: 156, height: 204, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1018, y: 33, width: 156, height: 205, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1018, y: 245, width: 156, height: 204, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h1v4-02",
        name: "LA 02 - H1V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-05-h1_v4_02.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 81, y: 77, width: 514, height: 329, rotation: 0, imageRotation: 0 },
            { id: "2", x: 816, y: 52, width: 293, height: 379, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1116, y: 52, width: 96, height: 122, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1116, y: 181, width: 96, height: 121, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1116, y: 310, width: 96, height: 121, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h1v4-03",
        name: "LA 03 - H1V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-05-h1_v4_03.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 138, y: 27, width: 401, height: 239, rotation: 0, imageRotation: 0 },
            { id: "2", x: 138, y: 273, width: 129, height: 181, rotation: 0, imageRotation: 0 },
            { id: "3", x: 274, y: 273, width: 128, height: 181, rotation: 0, imageRotation: 0 },
            { id: "4", x: 410, y: 273, width: 128, height: 181, rotation: 0, imageRotation: 0 },
            { id: "5", x: 868, y: 27, width: 293, height: 427, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h1v4-04",
        name: "LA 04 - H1V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-05-h1_v4_04.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 94, y: 51, width: 278, height: 381, rotation: 0, imageRotation: 0 },
            { id: "2", x: 380, y: 51, width: 201, height: 115, rotation: 0, imageRotation: 0 },
            { id: "3", x: 380, y: 173, width: 201, height: 259, rotation: 0, imageRotation: 0 },
            { id: "4", x: 769, y: 71, width: 241, height: 341, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1018, y: 71, width: 241, height: 341, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h1v4-05",
        name: "LA 05 - H1V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-05-h1_v4_05.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 116, y: 80, width: 218, height: 324, rotation: 0, imageRotation: 0 },
            { id: "2", x: 342, y: 80, width: 218, height: 324, rotation: 0, imageRotation: 0 },
            { id: "3", x: 771, y: 51, width: 278, height: 381, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1057, y: 51, width: 201, height: 115, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1057, y: 173, width: 201, height: 259, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h1v4-06",
        name: "LA 06 - H1V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-05-h1_v4_06.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 208, y: 51, width: 259, height: 381, rotation: 0, imageRotation: 0 },
            { id: "2", x: 834, y: 51, width: 115, height: 171, rotation: 0, imageRotation: 0 },
            { id: "3", x: 957, y: 51, width: 115, height: 171, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1080, y: 51, width: 114, height: 171, rotation: 0, imageRotation: 0 },
            { id: "5", x: 834, y: 230, width: 359, height: 202, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h1v4-07",
        name: "LA 07 - H1V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-05-h1_v4_07.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 0, y: 55, width: 626, height: 373, rotation: 0, imageRotation: 0 },
            { id: "2", x: 634, y: 55, width: 283, height: 373, rotation: 0, imageRotation: 0 },
            { id: "3", x: 924, y: 55, width: 136, height: 183, rotation: 0, imageRotation: 0 },
            { id: "4", x: 924, y: 245, width: 136, height: 183, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1067, y: 55, width: 285, height: 373, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h1v4-08",
        name: "LA 08 - H1V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-05-h1_v4_08.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 0, y: 55, width: 626, height: 373, rotation: 0, imageRotation: 0 },
            { id: "2", x: 634, y: 55, width: 283, height: 373, rotation: 0, imageRotation: 0 },
            { id: "3", x: 924, y: 55, width: 285, height: 373, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1216, y: 55, width: 136, height: 183, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1216, y: 245, width: 136, height: 183, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h1v4-09",
        name: "LA 09 - H1V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-05-h1_v4_09.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 0, y: 31, width: 676, height: 420, rotation: 0, imageRotation: 0 },
            { id: "2", x: 847, y: 31, width: 164, height: 206, rotation: 0, imageRotation: 0 },
            { id: "3", x: 847, y: 245, width: 164, height: 206, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1018, y: 31, width: 163, height: 206, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1018, y: 245, width: 163, height: 206, rotation: 0, imageRotation: 0 }
        ],
    }
];

